module.exports = __webpack_public_path__ + "2f3972976f7143e5c2168faea97f1a7a.pdf";